import { LOREAL_STATISTIC_ACTIONS, INITIAL_STATE } from '../constants';

export default function lorealStatisticReducer(state = INITIAL_STATE.LOREAL_STATISTIC_STATE, action) {
  const {error} = action.payload || {};

  switch(action.type) {
    case LOREAL_STATISTIC_ACTIONS.SET_STATISTIC_ERROR: {
      return {
        ...state,
        error
      };
    }
    default:
      return state;
  }
}